import React, { useEffect, useState } from 'react';
import './hotelMob.css';
import {
    Radio,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Box,
    Container,
    Typography,
    Button,
    MenuItem,
    Menu
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useUserAuth } from '../login/userAuthContext';
import { useNavigate } from 'react-router';
import CityMenu from '../dropdowns/dropdownCity';


const months = ["Jan'", "Feb'", "Mar'", "April", "May", "June", "July", "Aug'", "Sept'", "Oct'", "Nov'", "Dec'"];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const saerchBtnStyle = {
  fontSize: '14px',
  borderRadius: '15px',
  width: '100px',
  marginBottom:'50px'
}
const numberArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export default function HotelMobile() {

    const [city,setCity] =  useState("Goa");
    const [cityClicked, setCityClicked] = useState("false");
    const [value, setValue] = useState("group1");
    const [date,setDate] = useState();
    const [depDate, setDepDate] = useState();
    const [userDate, setUserDate] = useState(new Date());
    const [outDay, setOutDay] = useState(new Date());
    const {user} = useUserAuth();
    const navigate = useNavigate();
    useEffect(()=> {
      setUserDate(new Date(date));
    }, [date]);
    useEffect(()=> {
      setOutDay(new Date(depDate));
    }, [depDate])
    const handleChange = (e)=> {
        setValue(e.target.value);
    }
    function LocationCard(props){
      const handleLocation = ()=>{
        setCityClicked(true);
      }
        return(
            <div className='hotel-mob' onMouseOver={handleLocation}>
                <Typography variant='body2' fontWeight='bold' sx={{fontFamily:'Poppins'}}>{props.firstLine}</Typography>
                <Typography variant='h1' fontSize='40px' sx={{fontFamily:'Poppins'}}>{props.selectCity}</Typography>
                <Typography variant='body2' fontWeight='bold' sx={{fontFamily:'Poppins'}}>{props.country}</Typography>
            </div> 
        )
    }
    const [room, setRoom] = useState(1);
    const [adult, setAdult] = useState(2);
    function TravellerCount(){
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);
      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
      const handleSelectTagRoom = (e)=>{
        setRoom(e.target.value);
      }
      const handleSelectTagAdult = (e)=>{
        setAdult(e.target.value);
      }
      return (
        <div className='hotel-mob'>
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
            sx={{textTransform:'none'}}
          >
            Rooms & Guest
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem sx={{width:'60vw'}}>
              <Box 
              display='flex'
              sx={{width:'60vw', justifyContent:'space-around'}}
              >
                <Typography variant='body1' fontWeight='bold'>Rooms</Typography>
                <select onChange={handleSelectTagRoom} value={room}>
                  {numberArray.map(el=>{
                    return <option key={el} value={el}>{el}</option>
                  })}
                  </select>
              </Box>
            </MenuItem>
            <MenuItem sx={{width:'60vw'}}>
            <Box 
            display='flex'
            sx={{width:'60vw', justifyContent:'space-around'}}
            >
                <Typography variant='body1' fontWeight='bold'>Adults</Typography>
                <select onChange={handleSelectTagAdult} value={adult}>
                    {numberArray.map(el=>{
                      return <option key={el} value={el}>{el}</option>
                    })}
                  </select>
              </Box>
            </MenuItem>
            <MenuItem sx={{width:'60vw'}}>
            <Box 
            display='flex'
            sx={{width:'60vw', justifyContent:'space-around'}}
            >
                <Typography variant='body1' fontWeight='bold'>Children</Typography>
                <select>
                    {numberArray.map((el, idx)=>{
                      return <option key={el}>{idx}</option>
                    })}
                  </select>
              </Box>
            </MenuItem>
          </Menu>
          <div style={{display:'flex'}}><h1 style={{fontSize:'30px'}}>{room}</h1><h4>Room</h4><h1 style={{fontSize:'30px'}}>{adult}</h1><h4>Adults</h4></div>
        </div>
      );
    }
    function UtilityCard(props){
        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);
        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };
        const handleClose = () => {
            setAnchorEl(null);
        };
        useEffect(()=>{
          if(date && date.length>=10){
            setAnchorEl(null);
          }
      }, [date]);
      useEffect(()=>{
        if(depDate && depDate.length>=10){
          setAnchorEl(null);
        }
      }, [depDate]);
        const handleDateChange = (e)=>{
            if(props.options==="Check-In"){
                setDate(e.target.value);
            }else if(props.options==="Check-Out"){
                setDepDate(e.target.value);
            }
            setAnchorEl(null);
        }
        
        return (
        <div style={{textAlign:'left'}}>
        <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none'}}
      >
        {props.options}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem><input type='date' onChange={handleDateChange}/></MenuItem>
      </Menu>
    </div>
    )
    }
    function DateCard(props){
        return (
            <div className='hotel-mob'>
            <UtilityCard options={props.options} />
            <br />
            {props.enter && <div>
            {date ? <div>
            <Box display='flex'>
            <Typography variant='h1' fontSize='30px' lineHeight='0.5'>{userDate.getDate()}</Typography>
            <Typography variant='h3' fontSize='23px' lineHeight='0.5'>{months[userDate.getMonth()]}</Typography>
            <Typography variant='h3' fontSize='23px' lineHeight='0.5'>{userDate.getFullYear()}</Typography>
            </Box>
            <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[userDate.getDay()]}</Typography>
            </div> : 
            <div>
            <Box display='flex'>
            <Typography variant='h1' fontSize='30px' lineHeight='0.5'>{new Date().getDate()}</Typography>
            <Typography variant='h3' fontSize='23px' lineHeight='0.5'>{months[new Date().getMonth()]}</Typography>
            <Typography variant='h3' fontSize='23px' lineHeight='0.5'>{new Date().getFullYear()}</Typography>
            </Box>
            <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[new Date().getDay()]}</Typography>
            </div>
            }
        </div>}
        {!props.enter && <div>
        {depDate ? <div>
          <Box display='flex'>
          <Typography variant='h1' fontSize='30px' lineHeight='0.5'>{outDay.getDate()}</Typography>
          <Typography variant='h3' fontSize='23px' lineHeight='0.5'>{months[outDay.getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px' lineHeight='0.5'>{outDay.getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[outDay.getDay()]}</Typography>
        </div> : 
        <div>
          <Box display='flex'>
          <Typography variant='h1' fontSize='30px' lineHeight='0.5'>{new Date().getDate()}</Typography>
          <Typography variant='h3' fontSize='23px' lineHeight='0.5'>{months[new Date().getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px' lineHeight='0.5'>{new Date().getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[new Date().getDay()]}</Typography>
        </div>
        }
        
        </div>}
        </div>
        )

    }
    function LastPricingCard(){
      const [pricing, setPricing] = useState("0-1500");
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);
      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
      const handlePrice = (e)=>{
        setPricing(e.target.textContent);
        setAnchorEl(null);
      }
      return (
        <div className='hotel-mob'>
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
            sx={{textTransform:'none'}}
          >
            Price per Night
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={handlePrice}>0-1500</MenuItem>
            <MenuItem onClick={handlePrice}>1500-2500</MenuItem>
            <MenuItem onClick={handlePrice}>2500-4000</MenuItem>
            <MenuItem onClick={handlePrice}>4000-7000</MenuItem>
            <MenuItem onClick={handlePrice}>7000-10000</MenuItem>
          </Menu>
          <Typography variant='body2' fontWeight='bold'>Price per night</Typography>
          <Typography variant='div' component='h3'>{pricing}</Typography>
        </div>
      );
    }
    const handleTickets = ()=>{
      if(user){
        navigate('/tickets/hotel');
      }else if(!user){
        navigate('/login');
      }
    }
  return (
    <div>
        <div className='hotelMob'>
        <Container>
            <FormControl component="fieldset">
            <FormLabel component="legend"> </FormLabel>
            <RadioGroup name="tour" value={value} onChange={handleChange} sx={{fontWeight:'bold'}}>
            <Box
            display='flex'
            sx={{paddingTop: '35px'}}
            >
                <FormControlLabel value="group1" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Upto 4 Rooms" />
                <FormControlLabel value="group2" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Group Deals" />
                <button className='newHotel'>NEW</button>
            </Box>
            </RadioGroup>
            </FormControl>
        </Container>
        <div>
           <Box 
           display='flex'
           sx={{flexDirection:'column', backgroundColor:'white'}}>
            <LocationCard firstLine={"City, Property Name Or Location"} selectCity={city} country={"India"} />
            <DateCard options={'Check-In'} enter={true} />
            <DateCard options={'Check-Out'} enter={false} />
            <TravellerCount />
            <LastPricingCard />
           </Box>
        </div>
        
        <Container>
            <Button variant='contained' sx={saerchBtnStyle} onClick={handleTickets}>SEARCH</Button>
        </Container>
        </div>
        {cityClicked && <div className='posHotel'><CityMenu setterFunc={setCity} removeMenu={setCityClicked}/></div> }
    </div>
  )
}
